import { ValueUpdater } from '../../valueUpdater';
export class FlatRateUnit {
    static constructFromPlainObject(sourceFRU) {
        const fru = new FlatRateUnit(sourceFRU.number, sourceFRU.description, sourceFRU.amount, sourceFRU.type, sourceFRU.unit);
        fru.originalAmount = ValueUpdater.updateNonNullableNumber(fru.originalAmount, sourceFRU.originalAmount);
        fru.positionNumber = ValueUpdater.updateNullableNumber(fru.positionNumber, sourceFRU.positionNumber);
        fru.comment = ValueUpdater.updateNonNullableString(fru.comment, sourceFRU.comment);
        fru.grossPrice = ValueUpdater.updateNullableNumber(fru.grossPrice, sourceFRU.grossPrice);
        fru.isLocal = ValueUpdater.updateNonNullableBoolean(fru.isLocal, sourceFRU.isLocal);
        fru.isSelected = ValueUpdater.updateNonNullableBoolean(fru.isSelected, sourceFRU.isSelected);
        return fru;
    }
    constructor(number, description, amount, type, unit) {
        this.number = number;
        this.description = description;
        this.amount = amount;
        this.type = type;
        this.unit = unit;
        this.comment = '';
        this.grossPrice = null;
        this.isLocal = false;
        this.isSelected = false;
        this.positionNumber = null;
        this.originalAmount = amount;
    }
    getComment() {
        return this.comment;
    }
    setComment(comment) {
        this.comment = comment;
    }
    getDescription() {
        return this.description;
    }
    getNumber() {
        return this.number;
    }
    getType() {
        return this.type;
    }
    setType(type) {
        this.type = type;
    }
    getUnit() {
        return this.unit;
    }
    setUnit(unit) {
        this.unit = unit;
    }
    getAmount() {
        return this.amount;
    }
    setAmount(amount) {
        this.amount = amount;
    }
    getOriginalAmount() {
        return this.originalAmount;
    }
    getGrossPrice() {
        return this.grossPrice;
    }
    setGrossPrice(grossPrice) {
        this.grossPrice = grossPrice;
    }
    getIsLocal() {
        return this.isLocal;
    }
    setIsLocal(isLocal) {
        this.isLocal = isLocal;
    }
    getPositionNumber() {
        return this.positionNumber;
    }
    setPositionNumber(positionNumber) {
        this.positionNumber = positionNumber;
    }
    getIsSelected() {
        return this.isSelected;
    }
    setIsSelected(isSelected) {
        this.isSelected = isSelected;
    }
}
//# sourceMappingURL=flatRateUnit.js.map